/**
 * Utility function to prepare, build and get API and app URLs.
 *
 * FIXME: The existence and necessity of this utility or helper file
 * should be addressed in the future. This file should be living close
 * to the API/Service folder that is currently under construction.
 */

import URI from "urijs";

/**
 * Prepares the given URI.
 *
 * @param {String} uri     The URI to prepare.
 * @param {Object} options The prepare options.
 *
 * @returns The prepared URL
 */
function prepareUrl(uri, options = {}) {
  return uri.replace(/\{([^\}]+)\}/g, function (match, pattern) {
    return _.get(options, pattern.trim(), match);
  });
}

/**
 * Builds the URL with the given URI.
 *
 * @param {String} uri     The URI to prepare.
 * @param {Object} options The prepare options.
 *
 * @returns The URL.
 */
export function buildUrl(uri, options) {
  return URI(prepareUrl(uri, options)).normalize().toString();
}

/**
 * Gets the App URL.
 *
 * @param {String} uri     The URI to prepare.
 * @param {Object} options The prepare options.
 *
 * @returns The URL.
 */
export function getAppUrl(uri, options) {
  return URI("/app/" + prepareUrl(uri, options))
    .normalize()
    .toString();
}

/**
 * Gets the API URL.
 *
 * @param {String} uri     The URI to prepare.
 * @param {Object} options The prepare options.
 *
 * @returns The URL.
 */
export function getApiUrl(uri, options) {
  return URI("/app/api/" + prepareUrl(uri, options))
    .normalize()
    .toString();
}

/**
 * Gets the absolute of the given URI.
 *
 * @param {String} uri The URI to prepare.
 *
 * @returns The absolute.
 */
export function getAbsolute(uri) {
  return URI(uri).absoluteTo(window.location).toString();
}
